import { emptySankeyFormState } from 'utils/form';

// Compares two history states to determine if the flows or IDs have changed

// TODO: Unit test this method
export const compareHistoryStates = (
  A = emptySankeyFormState,
  B = emptySankeyFormState
) => {
  const { flows: flowsA, id: idA } = JSON.parse(A) as SankeyFormValues;
  const { flows: flowsB, id: idB } = JSON.parse(B) as SankeyFormValues;
  return {
    hasChangedFlows: JSON.stringify(flowsA) !== JSON.stringify(flowsB),
    hasChangedIDs: idA !== idB,
  };
};
